import { Chip, Typography } from "@mui/material";
import { Avatar } from "@unicity/design-system";

const AvatarChip = ({ id, imageUrl, name, clickHandler }) => {
  return (
    <Chip
      className="u-chip"
      variant="avatar"
      avatar={
        <Avatar
          id={`${id}-avatar`}
          alt={name}
          src={imageUrl}
          sx={{ width: 25, height: 25, fontSize: "calc(12px * var(--unicity-font-scale, 1))" }}
        />
      }
      label={<Typography style={{ fontSize: "calc(12px * var(--unicity-font-scale, 1))" }}>{name}</Typography>}
      data-test-id="avatar-chip"
      id={id}
      onClick={clickHandler}
      sx={{
        "&:hover": {
          cursor: "pointer",
        },
      }}
    />
  );
};

export { AvatarChip };
